import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';


Vue.use(VueRouter);

const routes = [
  {
    path: '/overview',
    name: 'processOverview',
    component: () => import('../pages/overview.vue'),
    meta: {
      keepAlive: false,
      title: '审批中心',
    },
  },
  {
    path: '/template-detail',
    name: 'processTemplateDetail',
    component: () => import('../pages/templateDetail.vue'),
    meta: {
      keepAlive: false,
      title: '发起审批',
    },
  },
  {
    path: '/instance-detail',
    name: 'processInstanceDetail',
    component: () => import('../pages/instanceDetail.vue'),
    meta: {
      keepAlive: false,
      title: '流程详情',
    },
  },
  {
    path: '/apply',
    name: 'processApply',
    component: () => import('../pages/apply.vue'),
    meta: {
      keepAlive: false,
      title: '发起审批',
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  console.log(urlParams)
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  next();
});

export default router;
